import { posSyncMessagesEn, posSyncMessagesFr } from '../components/settings/pos-sync/pos-sync-i18n.js';
import { campaignsMessagesEn, campaignsMessagesFr } from '../components/campaigns/campaigns-i18n.js';
import { customerFiltersMessagesEn, customerFiltersMessagesFr } from '../components/customers/customer-filters-i18n.js';

export default {
    en: {
        dateRangePreset: {
            thisWeek: "This week",
            lastWeek: "Last week",
            thisMonth: "This month",
            lastMonth: "Last month",
            thisQuarter: "This quarter",
            thisYear: "This year",
            last30Days: "Last 30 days",
        },
        legalstructure: {
            auto: "Self-employed (Micro-enterprise)",
            ei: "(EI) Sole Proprietorship",
            earl: "(EARL) Limited Liability Agricultural Company",
            eirl: "(EIRL) Limited Liability Sole Proprietorship",
            eurl: "(EURL) Single-member LLC",
            sa: "(SA) Public Limited Company",
            sarl: "(SARL) Limited Liability Company",
            sas: "(SAS) Simplified Joint-Stock Company",
            sasu: "(SASU) Single-member Simplified Joint-Stock Company",
            snc: "(SNC) General Partnership",
            scev: "(SCEV) Civic Exploitation Vineyard",
            scea: "(SCEA) Agricultural Civil Company",
        },
        agentcommission: {
            status: {
                waiting: "Waiting",
                billed: "Billed",
                paid: "Paid",
                ready: "Redy to bill",
                ignored: "Ignored",
            },
        },
        providerorder: {
            status: {
                draft: "Draft",
                to_be_processed: "To be processed",
                waiting: "Waiting",
                processing: "Processing",
                completed: "Completed",
                canceled: "Canceled",
            },
        },
        customerorder: {
            status: {
                to_validate: "To validate",
                draft: "Draft",
                validated: "Validated",
                to_be_processed: "To be processed",
                partially_processed: "Partially processed",
                waiting: "Waiting",
                processing: "In progress",
                completed: "Completed",
                canceled: "Canceled",
            },
            statusTooltip: {
                to_validate: "Order confirmed by the customer, awaiting your validation.",
                to_be_processed:
                    "Order validated, awaiting logistics processing (shipment or delivery).",
                partially_processed:
                    "At least one shipment exists, but some products still have to be scheduled.",
            },
        },
        salesinsights: {
            title: "Sales insights",
            betaChip: "Beta",
            dateFrom: "From",
            dateTo: "To",
            dateBasis: "Date used for filtering",
            buyerId: "Customer",
            buyerFilterAppliedFromTopBuyersLead: "Customer filter updated",
            buyerFilterAppliedFromTopBuyersTail: " — sales insights now focus on this account.",
            manufacturerFilterAppliedFromTableLead: "Manufacturer filter updated",
            manufacturerFilterAppliedFromTableTail: " — sales insights now focus on this manufacturer.",
            assignedToFilter: "Sales rep",
            manufacturer: "Manufacturer",
            providerFilter: "Supplier",
            tagsFilter: "Product tags",
            includeServices: "Include service sales",
            totalQuantity: "Quantity sold",
            totalAmountExclVat: "Amount excl. VAT",
            totalRevenueExclVat: "Gross revenue (excl. VAT)",
            averageRevenuePerMonth: "Avg. revenue per month",
            distinctBuyers: "Active customers",
            distinctOrders: "Orders",
            topReferences: "Top references",
            topBuyers: "Top customers",
            topAssignedUsers: "Top sales reps",
            topManufacturers: "Top manufacturers",
            topRegisterSales: "Register sales (POS)",
            topModes: {
                referencesDescription: "Products and catalog lines ranked by quantity sold.",
                buyersDescription: "Customer accounts ranked by quantity sold.",
                assignedDescription: "Sales reps ranked by quantity sold.",
                manufacturersDescription: "Manufacturers ranked by quantity sold.",
                registerDescription: "POS register revenue by sync configuration (no named customer).",
            },
            buyersForProduct: "Customers for this reference",
            basis: {
                validated: "Validation date",
                completed: "Completion date",
                paid: "Payment date",
                creation: "Creation date",
            },
            col: {
                rank: "Rank",
                reference: "Reference",
                manufacturer: "Manufacturer",
                quantity: "Quantity",
                amountExclVat: "Amount excl. VAT",
                marginExclVat: "Margin excl. VAT",
                buyers: "Customers",
                products: "References",
                buyer: "Customer",
                assignee: "Sales rep",
                ordersCount: "Orders",
                lastOrder: "Last order",
                posSync: "POS sync",
                establishment: "Establishment",
            },
            openFromCustomer: "Sales insights for this customer",
            exportCsv: "Export CSV",
            exportBuyersCsv: "Export breakdown (CSV)",
            exportFilename: "sales_insights.csv",
            exportBuyersFilename: "sales_insights_product_buyers.csv",
            showMore: "Show more",
            chartSectionTitle: "Sales evolution",
            chartInfoAriaLabel: "About this chart",
            chartSectionInfo:
                "Evolution of order totals over the period and filters selected above (period, customer, sales rep, manufacturer, supplier, product tags, services, etc.). When a manufacturer, supplier or tag is set, the chart uses matching order lines only (same rule as the breakdown tables). Choose resolution, date field used for buckets, and dataset below.",
            chartResolution: {
                day: "Day",
                week: "Week",
                month: "Month",
            },
            chartGrouping: {
                completed: "Completion date",
                paid: "Payment date",
                validated: "Order date",
            },
            chartModes: {
                aggregate: "Sales & revenue",
                userSales: "Sales per user",
                userRevenue: "Revenue per user",
                userMargin: "Margin per user",
                userCommission: "Commission per user",
            },
            datePreset: {
                last7Days: "Last 7 days",
                thisMonth: "This month",
                last12Months: "Last 12 months",
                thisYear: "This year",
                lastYear: "Last year (Jan 1 – Dec 31)",
                allTime: "All time",
                custom: "Custom range",
            },
            datePeriodLabel: "Time range",
            filtersSectionPeriod: "Period",
            filtersSectionCriteria: "Criteria",
            advancedSettings: "Advanced settings",
            reloadFromServer: "Reload data from server",
            advancedDialogTitle: "Advanced settings",
            advancedDialogApply: "Apply",
            advancedDialogCancel: "Cancel",
            billingAccountFilter: "Buyer billing account (orders)",
            clearAllFilters: "Clear all filters",
            removeFilter: "Remove filter",
            emptyTitle: "No sales yet",
            emptyDescription:
                "Sales insights help you track top products, customers and sales reps, follow revenue over time, and spot trends. Create your first sale to start filling this dashboard.",
            manageSales: "Manage sales",
        },
        customerinvoice: {
            status: {
                draft: "Draft",
                paid: "Paid",
                cashed: "Cashed",
                tosend: "To send",
                pending: "Pending invoice",
                waitingpayment: "Waiting for payment",
                overdue: "Payment overdue",
                due: "Payment due",
            },
        },
        providerinvoice: {
            status: {
                cashed: "Cashed",
                draft: "Draft",
                due: "Payment due",
                missing: "Missing file",
                overdue: "Payment overdue",
                paid: "Paid",
                pendinginvoice: "Pending invoice",
                pending: "Pending invoice",
                tovalidate: "To validate",
                waiting: "Waiting",
                waitingpayment: "Waiting for payment",
            },
        },
        orderinvoices: {
            status: {
                order_canceled: "Order canceled",
                missing_invoices: "Missing invoices",
                waiting_validation: "Draft to validate",
                to_upload: "Invoice to upload",
                draft_to_validate: "Draft to validate",
                waiting_vendor: "Waiting for vendor invoice",
                to_send: "To send",
                paid: "Paid",
                payment_overdue: "Payment overdue",
                payment_due: "Payment due",
                waitingpayment: "Waiting for payment",
            },
        },
        shipment: {
            status: {
                draft: "Draft",
                waiting: "Waiting",
                to_be_processed: "To be processed",
                preparing: "Preparing",
                prepared: "Prepared",
                shipping: "Shipping in progress",
                picked_up: "Picked up",
                delivered: "Delivered",
                canceled: "Canceled",
                complete: "Completed",
                waitingpayment: "Waiting for payment",
            },
        },
        receipt: {
            status: {
                draft: "Draft",
                waiting: "Waiting",
                handling: "Handling in progress",
                to_be_processed: "To be processed",
                complete: "Complete",
                partial: "Partial",
                missing: "Missing",
                canceled: "Canceled",
            },
            kind: {
                standard: "Standard",
                return: "Return",
            },
            kindLabel: "Type",
        },
        persona: {
            wholesaler: "Wholesaler",
            retailer: "Retailer",
            hospitality_group: "Restaurant / hospitality group",
            manufacturer: "Manufacturer",
            agent: "Agent",
            other: "Other",
        },
        contactRoles: {
            management: "Management",
            purchasing: "Purchasing",
            accounting: "Accounting",
            sales: "Sales",
            logistics: "Logistics / receiving",
            kitchen: "Kitchen",
            cellar: "Cellar / sommellerie",
            other: "Other",
        },
        contactAudiences: {
            suppliers: "My suppliers",
            customers: "My customers",
        },
        errors: {
            unknown_error_occurred: "Unknown error occurred",
            field_errors: "Fields errors, check form errors and try again",
            server_reported_bad_form_values:
                "Server reported bad form values, please check values and try again",
            this_action_cannot_be_performed: "This action cannot be performed.",
            permission_denied: "Permission denied",
            an_unexpected_error_happened:
                "An unexpected error happened, please contact us for support",
            anUnexpectedErrorHappened: "An unexpected error happened",
            invalidOrdering: "Ordering field is invalid. Please change the ordering field and try again.",
            unallowedPermissions: "Permissions not allowed for this profile:",
        },
        catalogentry: {
            labels: {
                inclVat: "incl. VAT",
                exclVat: "excl. VAT",
                month: "month",
                customAlgorithm: "Custom algorithm",
            },
        },
        customer: {
            type: {
                individual: "Individual",
                company: "Company",
            },
            no_catalogs_assigned: "No catalogs assigned",
        },
        completeAddress: {
            title: "Complétez votre adresse",
            instructions: "Veuillez compléter votre adresse pour continuer.",
        },
        external: "(external)",
        cancel: "Cancel",
        confirm: "Confirm",
        save: "Save",
        viewAll: "View all",
        false: "false",
        error: "Error",
        edit: "Edit",
        mainAddress: "Main address",
        recoverPassword: "Recover password",
        resetPassword: "Reset password",
        welcome: "Welcome",
        register: "Register",
        connect: "Connect",
        bulkCompleted: "Action groupée terminée",
        newInvoice: "New invoice",
        didNotFindHelpContent: "Did not find help content.",
        true: "true",
        yes: "yes",
        no: "no",
        Yes: "Yes",
        No: "No",
        andmore: "more",
        noUser: "No user",
        agents: "Agents",
        theFollowingMandatoryFieldsHaveNotBeenMapped:
            "The following mandatory fields have not been mapped:",
        anUnexpectedErrorHappenedPleaseContactUsForSupport:
            "An unexpected error happened, please contact us for support",
        dateRangeFromTo: "from {start} to {end}",
        dateRange: {
            label: "Date range",
            placeholder: "Select a period",
            apply: "Apply",
            cancel: "Cancel",
            modeLabel: "Dataset",
            groupByLabel: "Group by",
        },
        navigation: {
            home: "Home",
            invitations: "Invitations",
            providers: "Providers",
            sell: "Sell",
            sales: "Sales",
            salesInsights: "Statistics",
            search: "Search",
            commissions: "Commissions",
            customers: "Customers",
            communications: "Campaigns",
            customersInvoices: "Customers invoices",
            invoices: "Invoices",
            products: "Products",
            catalogs: "Catalogs",
            allocations: "Allocations",
            logistics: "Logistics",
            stock: "Stock",
            shipments: "Shipments",
            receipts: "Receipts",
            movements: "Movements",
            logisticsProviders: "Logistics providers",
            inventory: "Inventory",
            buy: "Buy",
            purchaseOrders: "Purchase orders",
            purchaseOrdersToApprove: "To approve",
            providersInvoices: "Providers invoices",
            comparator: "Comparator",
            replenish: "Replenishment",
            toOrder: "To order",
            technicalSheets: "Technical sheets",
            production: "Production",
            radar: "Radar",
            agents: "Agents",
            establishments: "Establishments",
            caisses: "Cash registers",
            billing: "Billing",
            configuration: "Configuration",
            deliverySites: "My addresses",
            warehouses: "Warehouses",
            productTypes: "Product types",
            feedback: "Feedback",
        },
        status_raw: "Status",
        status: {
            canceled: "Canceled",
            closed: "Closed",
            complete: "Complete",
            completed: "Completed",
            delivered: "Delivered",
            exhausted: "Exhausted",
            handling: "Handling",
            missing: "Missing",
            new: "New",
            opened: "Opened",
            partial: "Partial",
            pending: "Pending",
            pickedUp: "Picked up",
            prepared: "Prepared",
            preparing: "Preparing",
            processed: "Processed",
            processing: "Processing",
            shipping: "Shipping",
            waiting: "Waiting",
        },
        // Countries - English (fallback to original names)
        country: {
            ad: "Andorra",
            ae: "United Arab Emirates",
            af: "Afghanistan",
            ag: "Antigua and Barbuda",
            ai: "Anguilla",
            al: "Albania",
            am: "Armenia",
            ao: "Angola",
            aq: "Antarctica",
            ar: "Argentina",
            as: "American Samoa",
            at: "Austria",
            au: "Australia",
            aw: "Aruba",
            ax: "Åland Islands",
            az: "Azerbaijan",
            ba: "Bosnia and Herzegovina",
            bb: "Barbados",
            bd: "Bangladesh",
            be: "Belgium",
            bf: "Burkina Faso",
            bg: "Bulgaria",
            bh: "Bahrain",
            bi: "Burundi",
            bj: "Benin",
            bl: "Saint Barthélemy",
            bm: "Bermuda",
            bn: "Brunei",
            bo: "Bolivia",
            bq: "Caribbean Netherlands",
            br: "Brazil",
            bs: "Bahamas",
            bt: "Bhutan",
            bv: "Bouvet Island",
            bw: "Botswana",
            by: "Belarus",
            bz: "Belize",
            ca: "Canada",
            cc: "Cocos Islands",
            cd: "Democratic Republic of the Congo",
            cf: "Central African Republic",
            cg: "Republic of the Congo",
            ch: "Switzerland",
            ci: "Côte d'Ivoire",
            ck: "Cook Islands",
            cl: "Chile",
            cm: "Cameroon",
            cn: "China",
            co: "Colombia",
            cr: "Costa Rica",
            cu: "Cuba",
            cv: "Cape Verde",
            cw: "Curaçao",
            cx: "Christmas Island",
            cy: "Cyprus",
            cz: "Czech Republic",
            de: "Germany",
            dj: "Djibouti",
            dk: "Denmark",
            dm: "Dominica",
            do: "Dominican Republic",
            dz: "Algeria",
            ec: "Ecuador",
            ee: "Estonia",
            eg: "Egypt",
            eh: "Western Sahara",
            er: "Eritrea",
            es: "Spain",
            et: "Ethiopia",
            fi: "Finland",
            fj: "Fiji",
            fk: "Falkland Islands",
            fm: "Micronesia",
            fo: "Faroe Islands",
            fr: "France",
            ga: "Gabon",
            gb: "United Kingdom",
            gd: "Grenada",
            ge: "Georgia",
            gf: "French Guiana",
            gg: "Guernsey",
            gh: "Ghana",
            gi: "Gibraltar",
            gl: "Greenland",
            gm: "Gambia",
            gn: "Guinea",
            gp: "Guadeloupe",
            gq: "Equatorial Guinea",
            gr: "Greece",
            gs: "South Georgia and the South Sandwich Islands",
            gt: "Guatemala",
            gu: "Guam",
            gw: "Guinea-Bissau",
            gy: "Guyana",
            hk: "Hong Kong",
            hm: "Heard Island and McDonald Islands",
            hn: "Honduras",
            hr: "Croatia",
            ht: "Haiti",
            hu: "Hungary",
            id: "Indonesia",
            ie: "Ireland",
            il: "Israel",
            im: "Isle of Man",
            in: "India",
            io: "British Indian Ocean Territory",
            iq: "Iraq",
            ir: "Iran",
            is: "Iceland",
            it: "Italy",
            je: "Jersey",
            jm: "Jamaica",
            jo: "Jordan",
            jp: "Japan",
            ke: "Kenya",
            kg: "Kyrgyzstan",
            kh: "Cambodia",
            ki: "Kiribati",
            km: "Comoros",
            kn: "Saint Kitts and Nevis",
            kp: "North Korea",
            kr: "South Korea",
            kw: "Kuwait",
            ky: "Cayman Islands",
            kz: "Kazakhstan",
            la: "Laos",
            lb: "Lebanon",
            lc: "Saint Lucia",
            li: "Liechtenstein",
            lk: "Sri Lanka",
            lr: "Liberia",
            ls: "Lesotho",
            lt: "Lithuania",
            lu: "Luxembourg",
            lv: "Latvia",
            ly: "Libya",
            ma: "Morocco",
            mc: "Monaco",
            md: "Moldova",
            me: "Montenegro",
            mf: "Saint Martin",
            mg: "Madagascar",
            mh: "Marshall Islands",
            mk: "North Macedonia",
            ml: "Mali",
            mm: "Myanmar",
            mn: "Mongolia",
            mo: "Macau",
            mp: "Northern Mariana Islands",
            mq: "Martinique",
            mr: "Mauritania",
            ms: "Montserrat",
            mt: "Malta",
            mu: "Mauritius",
            mv: "Maldives",
            mw: "Malawi",
            mx: "Mexico",
            my: "Malaysia",
            mz: "Mozambique",
            na: "Namibia",
            nc: "New Caledonia",
            ne: "Niger",
            nf: "Norfolk Island",
            ng: "Nigeria",
            ni: "Nicaragua",
            nl: "Netherlands",
            no: "Norway",
            np: "Nepal",
            nr: "Nauru",
            nu: "Niue",
            nz: "New Zealand",
            om: "Oman",
            pa: "Panama",
            pe: "Peru",
            pf: "French Polynesia",
            pg: "Papua New Guinea",
            ph: "Philippines",
            pk: "Pakistan",
            pl: "Poland",
            pm: "Saint Pierre and Miquelon",
            pn: "Pitcairn Islands",
            pr: "Puerto Rico",
            ps: "Palestine",
            pt: "Portugal",
            pw: "Palau",
            py: "Paraguay",
            qa: "Qatar",
            re: "Réunion",
            ro: "Romania",
            rs: "Serbia",
            ru: "Russia",
            rw: "Rwanda",
            sa: "Saudi Arabia",
            sb: "Solomon Islands",
            sc: "Seychelles",
            sd: "Sudan",
            se: "Sweden",
            sg: "Singapore",
            sh: "Saint Helena",
            si: "Slovenia",
            sj: "Svalbard and Jan Mayen",
            sk: "Slovakia",
            sl: "Sierra Leone",
            sm: "San Marino",
            sn: "Senegal",
            so: "Somalia",
            sr: "Suriname",
            ss: "South Sudan",
            st: "São Tomé and Príncipe",
            sv: "El Salvador",
            sx: "Sint Maarten",
            sy: "Syria",
            sz: "Eswatini",
            tc: "Turks and Caicos Islands",
            td: "Chad",
            tf: "French Southern Territories",
            tg: "Togo",
            th: "Thailand",
            tj: "Tajikistan",
            tk: "Tokelau",
            tl: "Timor-Leste",
            tm: "Turkmenistan",
            tn: "Tunisia",
            to: "Tonga",
            tr: "Turkey",
            tt: "Trinidad and Tobago",
            tv: "Tuvalu",
            tw: "Taiwan",
            tz: "Tanzania",
            ua: "Ukraine",
            ug: "Uganda",
            um: "United States Minor Outlying Islands",
            us: "United States",
            uy: "Uruguay",
            uz: "Uzbekistan",
            va: "Vatican City",
            vc: "Saint Vincent and the Grenadines",
            ve: "Venezuela",
            vg: "British Virgin Islands",
            vi: "U.S. Virgin Islands",
            vn: "Vietnam",
            vu: "Vanuatu",
            wf: "Wallis and Futuna",
            ws: "Samoa",
            ye: "Yemen",
            yt: "Mayotte",
            za: "South Africa",
            zm: "Zambia",
            zw: "Zimbabwe",
        },
        // Variables
        variables: {
            amounts: "Amounts",
            billed: "Billed",
            billedName: "Billed Name",
            billingAddress: "Billing Address",
            buyer: "Buyer",
            buyerName: "Buyer Name",
            contactEmail: "Contact Email",
            contactPhoneNumbers: "Contact Phone Numbers",
            currency: "Currency",
            currencySymbol: "Currency Symbol",
            customer: "Customer",
            daysOverdue: "Days Overdue",
            dueDate: "Due Date",
            dueDateLong: "Due date (long format)",
            insertVariables: "Insert variables",
            invoiceDate: "Invoice Date",
            invoiceDateLong: "Invoice Date (Long)",
            invoiceId: "Invoice ID",
            invoiceInformation: "Invoice information",
            issuer: "Issuer",
            issuerAddress: "Issuer address",
            issuerContactEmail: "Issuer contact email",
            issuerContactPhoneNumbers: "Issuer Phone Numbers",
            issuerName: "Issuer name",
            items: "Items",
            itemsCount: "Items Count",
            itemsSummary: "Items Summary",
            orderDate: "Order Date",
            order: "Order Information",
            orderId: "Order ID",
            parties: "Parties",
            seller: "Seller",
            sellerAddress: "Seller Address",
            sellerContactEmail: "Seller Contact Email",
            sellerContactPhoneNumbers: "Seller Phone Numbers",
            sellerName: "Issuer name",
            totalExclVat: "Total excl. VAT",
            totalInclVat: "Total Incl. VAT",
            totalVatAmount: "Total VAT amount",
            validatedDate: "Order date",
            validatedDateLong: "Order date (long format)",
        },
        filenames: {
            customerOrders: "customer_orders.csv",
            customerOrderItems: "customer_order_items.csv",
            customerInvoices: "customer_{customer_name}_invoices.csv",
            customerInvoiceItems: "customer_{customer_name}_invoice_items.csv",
            providerInvoices: "provider_invoices.csv",
            providerInvoiceItems: "invoice_{invoice_number}_details.csv",
            providerOrders: "provider_orders.csv",
            providerOrderItems: "provider_order_items.csv",
            shipments: "shipments.csv",
            shipmentItems: "shipment_{shipment_id}_items.csv",
            receipts: "receipts.csv",
            receiptItems: "receipt_{receipt_id}_items.csv",
            products: "products.csv",
            catalogs: "catalogs.csv",
            catalogEntries: "catalog_{catalog_name}_entries.csv",
            productCatalogEntries: "catalog_{catalog_name}_product_entries.csv",
            catalogsStockExport: "catalogs_stock_export.csv",
            providerCatalogEntries: "provider_products.csv",
            customers: "customers.csv",
            providers: "providers.csv",
            allocations: "allocations.csv",
            permissions: "permissions.csv",
            groups: "groups.csv",
            movements: "movements.csv",
            movementsInventory: "movements_inventory.csv",
            inventory: "inventaire_{date}.csv",
            stockProducts: "stock_products.csv",
            commissions: "commissions.csv",
            commissionItems: "commission_items.csv",
            labels: "labels.pdf",
            invoicePdf: "invoice_{invoice_number}.pdf",
            creditNotePdf: "credit_note_{invoice_number}.pdf",
            productionPickList: "pick_list_{establishment}_{date}.pdf",
            productionProductionSheet: "production_sheet_{establishment}_{date}.pdf",
            stock: "stock.csv",
        },
        inventoryPlaceholderDate: "Please select a date above to display the inventory table.",
        inventoryPlaceholderDateAndCustomer: "Please select a date and a customer above to display the inventory table.",
        technicalSheet: "Technical Sheet",
        product: "Product",
        quantity: "Quantity",
        loss: "Loss",
        cost: "Cost",
        components: "Components",
        totalCost: "Total Cost",
        margin: "Margin",
        marginPercentage: "Margin %",
        description: "Description",
        noDescription: "No description",
        sellingPrice: "Selling Price",
        sellingPriceInclVat: "Selling Price (incl. VAT)",
        creationDate: "Creation Date",
        modificationDate: "Modification Date",
        bundleInformation: "Technical Sheet Information",
        search: "Search",
        units: {
            gram: "Gram (g)",
            kilogram: "Kilogram (kg)",
            liter: "Liter (L)",
            milliliter: "Milliliter (ml)",
            centiliter: "Centiliter (cl)",
            piece: "Piece (pc)",
            grams: "Grams (g)",
            kilograms: "Kilograms (kg)",
            liters: "Liters (L)",
            milliliters: "Milliliters (ml)",
            centiliters: "Centiliters (cl)",
            pieces: "Pieces (pc)",
        },
        unitSymbols: {
            g: "g",
            kg: "kg",
            l: "L",
            L: "L",
            ml: "ml",
            cl: "cl",
            pc: "",
        },
        unitTypes: {
            weight: "Weight",
            volume: "Volume",
            piece: "Piece",
        },
        purchaseApproval: {
            title: "Purchase approval",
            description: "Configure how purchase approval limits are calculated.",
            amountBasisLabel: "Amount used for purchase approval limits",
            amountBasisExclVat: "Excl. VAT",
            amountBasisInclVat: "Incl. VAT",
            unlimited: "Unlimited",
            limitGlobalLabel: "Purchase approval limit (global)",
            limitGlobalHint: "Leave empty for inheritance from group. 0 always requires submission.",
            blockers: {
                amountOverLimit: "Amount exceeds your approval limit",
                approvalPending: "A purchase approval request is already pending",
                approvalNotPending: "No pending purchase approval request",
                approvalRequired: "Purchase approval is required before validation",
                validatePermissionRequired:
                    "You do not have permission to validate provider orders",
                changePermissionRequired:
                    "You do not have permission to change provider orders",
                incompleteOrder: "Order prerequisites are not met",
                missingDeliveryAddress: "Delivery address is incomplete",
                incompleteEntityInfo: "Company information is incomplete",
                orderSellerAddressMissing: "Provider email address is missing",
                orderAlreadyReady: "Order has already been validated",
                approvalSuborderReadonly:
                    "Purchase approval must be managed on the parent order",
                unknown: "Validation is not possible for an unknown reason",
            },
        },
        customerTags: "Customer tags",
        assignedTo: "Assigned to",
        invoiceStatus: "Invoice status",
        deliveryDateDesired: "Desired delivery date",
        lowstock: "Low stock",
        orderType: {
            fieldName: "Order type",
            brokerageAndResale: "Brokerage and resale",
            brokerageOnly: "Brokerage only",
            resaleOnly: "Resale only",
        },
        stockRequired: "Please select a stock",
        noValidItemsToDestock: "No valid items to destock",
        departureWarehouseUpdateFailed: "Failed to update departure warehouse",
        pickWarehouseTitle: "Select a warehouse",
        pickWarehouseHint: "Please select a departure warehouse from the list below.",
        "Fields errors, check form errors and try again":
            "Fields errors, check form errors and try again",
        warning: "Warning",
        "Registering failed": "Registering failed",
        messages: {
            bulkActionPartiallyCompleted:
                "Bulk action completed with {errorcount} error(s)",
            bulkActionFailed: "Bulk action failed for {errorcount} item(s)",
            missingPermission:
                "You do not have permission to perform this action.",
            cannotCompleteMasterOrderWithSuborders:
                "This order has provider sub-orders. Finalize each provider order individually instead of this order.",
            cannotCompleteSuborderAsAgent:
                "This sub-order is handled by a connected provider. Only the provider can finalize it.",
        },
        deliverysite: {
            cannotArchiveTitle: "Cannot archive delivery site",
            cannotArchiveLinkedToWarehouse:
                "This delivery site is linked to a warehouse and cannot be archived. Archive or delete the warehouse first (Settings → Warehouses).",
        },
        ...posSyncMessagesEn,
        ...campaignsMessagesEn,
        ...customerFiltersMessagesEn,
    },
    fr: {
        dateRangePreset: {
            thisWeek: "Cette semaine",
            lastWeek: "Semaine dernière",
            thisMonth: "Ce mois-ci",
            lastMonth: "Le mois dernier",
            thisQuarter: "Ce trimestre",
            thisYear: "Cette année",
            last30Days: "30 derniers jours",
        },
        legalstructure: {
            auto: "Auto-entrepreneur (Micro-entreprise)",
            ei: "EI (Entreprise Individuelle)",
            eirl: "EIRL (Entreprise Individuelle à Responsabilité Limitée)",
            eurl: "EURL (Entreprise Unipersonnelle à Responsabilité Limitée)",
            sa: "SA (Société Anonyme)",
            sarl: "SARL (Société à Responsabilité Limitée)",
            sas: "SAS (Société par Actions Simplifiée)",
            sasu: "SASU (Société par Actions Simplifiée Unipersonnelle)",
            earl: "EARL (Entreprise à Responsabilité Limitée)",
            scea: "SCEA (Société Civile d'Exploitation Agricole)",
            scev: "SCEV (Société Civile d'Exploitation Viticole)",
            snc: "SNC (Société en Nom Collectif)",
        },
        agentcommission: {
            status: {
                waiting: "En attente",
                billed: "Facturée",
                paid: "Payée",
                ready: "Prête à facturer",
                ignored: "Ignorée",
            },
        },
        providerorder: {
            status: {
                draft: "Brouillon",
                to_be_processed: "À traiter",
                waiting: "En attente",
                processing: "En cours",
                completed: "Finalisée",
                canceled: "Annulée",
            },
        },
        customerorder: {
            status: {
                to_validate: "À valider",
                draft: "Brouillon",
                validated: "Validée",
                to_be_processed: "À traiter",
                partially_processed: "Partiellement traitée",
                waiting: "En attente",
                processing: "En cours",
                completed: "Finalisée",
                canceled: "Annulée",
            },
            statusTooltip: {
                to_validate: "Commande confirmée par le client, en attente de votre validation.",
                to_be_processed:
                    "Commande validée, en attente de traitement logistique (expédition ou livraison).",
                partially_processed:
                    "Au moins une expédition existe, mais des produits restent à programmer.",
            },
        },
        salesinsights: {
            title: "Analyse des ventes",
            betaChip: "Beta",
            dateFrom: "Du",
            dateTo: "Au",
            dateBasis: "Date utilisée pour filtrer",
            buyerId: "Client",
            buyerFilterAppliedFromTopBuyersLead: "Filtre client mis à jour",
            buyerFilterAppliedFromTopBuyersTail: " : l'analyse des ventes porte désormais sur ce compte.",
            manufacturerFilterAppliedFromTableLead: "Filtre fabricant mis à jour",
            manufacturerFilterAppliedFromTableTail: " : l'analyse des ventes porte sur ce fabricant.",
            assignedToFilter: "Commercial",
            manufacturer: "Fabricant",
            providerFilter: "Fournisseur",
            tagsFilter: "Tags produit",
            includeServices: "Inclure les ventes de services",
            totalQuantity: "Quantité vendue",
            totalAmountExclVat: "Montant HT",
            totalRevenueExclVat: "Revenu brut HT",
            averageRevenuePerMonth: "Revenu moyen / mois",
            distinctBuyers: "Clients actifs",
            distinctOrders: "Commandes",
            topReferences: "Top références",
            topBuyers: "Top clients",
            topAssignedUsers: "Top commerciaux",
            topManufacturers: "Top fabricants",
            topRegisterSales: "Ventes caisse (POS)",
            topModes: {
                referencesDescription: "Produits et références classés par quantité vendue.",
                buyersDescription: "Comptes clients classés par quantité vendue.",
                assignedDescription: "Commerciaux classés par quantité vendue.",
                manufacturersDescription: "Fabricants classés par quantité vendue.",
                registerDescription: "Chiffre d'affaires caisse par synchro POS (sans client nommé).",
            },
            buyersForProduct: "Clients pour cette référence",
            basis: {
                validated: "Date de validation",
                completed: "Date de clôture",
                paid: "Date de paiement",
                creation: "Date de création",
            },
            col: {
                rank: "Rang",
                reference: "Référence",
                manufacturer: "Fabricant",
                quantity: "Quantité",
                amountExclVat: "Montant HT",
                marginExclVat: "Marge HT",
                buyers: "Clients",
                products: "Références",
                buyer: "Client",
                assignee: "Commercial",
                ordersCount: "Commandes",
                lastOrder: "Dernière commande",
                posSync: "Synchro caisse",
                establishment: "Établissement",
            },
            openFromCustomer: "Analyse des ventes pour ce client",
            exportCsv: "Exporter CSV",
            exportBuyersCsv: "Exporter le détail (CSV)",
            exportFilename: "analyse_ventes.csv",
            exportBuyersFilename: "analyse_ventes_clients_produit.csv",
            showMore: "Afficher plus",
            chartSectionTitle: "Évolution des ventes",
            chartInfoAriaLabel: "À propos de ce graphique",
            chartSectionInfo:
                "Évolution des montants de commandes sur la période et les filtres choisis ci-dessus (période, client, commercial, fabricant, fournisseur, tags produit, services, etc.). Si un fabricant, un fournisseur ou un tag est renseigné, le graphique ne compte que les lignes de commande correspondantes (même règle que les tableaux de détail). Choisissez la résolution, la date utilisée pour regrouper les points, et le jeu de données ci-dessous.",
            chartResolution: {
                day: "Jour",
                week: "Semaine",
                month: "Mois",
            },
            chartGrouping: {
                completed: "Date de finalisation",
                paid: "Date de paiement",
                validated: "Date de commande",
            },
            chartModes: {
                aggregate: "Ventes et revenus",
                userSales: "Ventes par utilisateur",
                userRevenue: "Revenus par utilisateur",
                userMargin: "Marge par utilisateur",
                userCommission: "Commissions par utilisateur",
            },
            datePreset: {
                last7Days: "7 derniers jours",
                thisMonth: "Ce mois-ci",
                last12Months: "12 derniers mois",
                thisYear: "Cette année",
                lastYear: "L'année dernière",
                allTime: "Depuis toujours",
                custom: "Période personnalisée",
            },
            datePeriodLabel: "Période",
            filtersSectionPeriod: "Période",
            filtersSectionCriteria: "Critères",
            advancedSettings: "Réglages avancés",
            reloadFromServer: "Actualiser les données depuis le serveur",
            advancedDialogTitle: "Configuration avancée",
            advancedDialogApply: "Appliquer",
            advancedDialogCancel: "Annuler",
            billingAccountFilter: "Compte de facturation (client)",
            clearAllFilters: "Effacer tous les filtres",
            removeFilter: "Retirer le filtre",
            emptyTitle: "Aucune vente pour le moment",
            emptyDescription:
                "L'analyse des ventes vous permet de suivre vos meilleures références, clients et commerciaux, d'observer l'évolution du chiffre d'affaires et de repérer les tendances. Créez votre première vente pour alimenter ce tableau de bord.",
            manageSales: "Gérer les ventes",
        },
        customerinvoice: {
            status: {
                draft: "Brouillon",
                paid: "Payée",
                cashed: "Encaissée",
                tosend: "À envoyer",
                pending: "Facture en attente",
                waitingpayment: "En attente de paiement",
                overdue: "Paiement en retard",
                due: "Paiement dû",
            },
        },
        providerinvoice: {
            status: {
                cashed: "Encaissée",
                draft: "Brouillon",
                due: "Paiement dû",
                missing: "Fichier manquant",
                overdue: "Paiement en retard",
                paid: "Payée",
                pendinginvoice: "En attente de paiement",
                pending: "Facture en attente",
                tovalidate: "À valider",
                waiting: "En attente",
                waitingpayment: "En attente de paiement",
            },
        },
        orderinvoices: {
            status: {
                order_canceled: "Commande annulée",
                missing_invoices: "Factures manquantes",
                waiting_validation: "Brouillon à valider",
                to_upload: "Facture à déposer",
                draft_to_validate: "Brouillon à valider",
                waiting_vendor: "En attente de facture",
                to_send: "À envoyer",
                paid: "Payée",
                payment_overdue: "Paiement en retard",
                payment_due: "Paiement dû",
                waitingpayment: "En attente de paiement",
            },
        },
        shipment: {
            status: {
                draft: "Brouillon",
                waiting: "En attente",
                to_be_processed: "À traiter",
                preparing: "En préparation",
                prepared: "Préparée",
                shipping: "En cours d'expédition",
                picked_up: "Retirée",
                waitingpayment: "En attente de paiement",
                delivered: "Livrée",
                canceled: "Annulée",
                complete: "Finalisée",
            },
        },
        receipt: {
            status: {
                draft: "Brouillon",
                waiting: "En attente",
                handling: "En cours de traitement",
                to_be_processed: "À traiter",
                complete: "Complète",
                partial: "Partielle",
                missing: "Manquante",
                canceled: "Annulée",
            },
            kind: {
                standard: "Standard",
                return: "Retour",
            },
            kindLabel: "Type",
        },
        persona: {
            wholesaler: "Grossiste",
            retailer: "Détaillant",
            hospitality_group: "Groupe de restauration / hôtellerie",
            manufacturer: "Fabricant",
            agent: "Agent commercial",
            other: "Autre",
        },
        contactRoles: {
            management: "Direction",
            purchasing: "Achats",
            accounting: "Comptabilité",
            sales: "Commercial",
            logistics: "Logistique / réception",
            kitchen: "Cuisine",
            cellar: "Cave / sommellerie",
            other: "Autre",
        },
        contactAudiences: {
            suppliers: "Mes fournisseurs",
            customers: "Mes clients",
        },
        customer: {
            type: {
                individual: "Particulier",
                company: "Entreprise",
            },
            no_catalogs_assigned: "Aucun catalogue assigné",
        },
        errors: {
            unknown_error_occurred: "Une erreur inconnue s'est produite",
            field_errors: "Erreurs de champs, veuillez corriger et réessayer",
            server_reported_bad_form_values:
                "Le serveur a rejeté les valeurs du formulaire, veuillez vérifier et essayer à nouveau",
            this_action_cannot_be_performed:
                "Cette action ne peut pas être effectuée.",
            permission_denied: "Permission refusée",
            an_unexpected_error_happened:
                "Une erreur inattendue s'est produite, veuillez nous contacter pour obtenir de l'aide",
            anUnexpectedErrorHappened: "Une erreur innatendue est survenue",
            invalidOrdering: "Ordre de tri demandé est invalide. Veuillez changer le champ de tri et réessayer.",
            unallowedPermissions: "Permissions non autorisées pour ce profil :",
        },
        catalogentry: {
            labels: {
                inclVat: "TTC",
                exclVat: "HT",
                month: "mois",
                customAlgorithm: "Algorithme personnalisé",
            },
        },
        completeAddress: {
            title: "Complétez votre adresse",
            instructions: "Veuillez compléter votre adresse pour continuer.",
        },
        bulkCompleted: "Action groupée terminée",
        external: "(externe)",
        cancel: "Annuler",
        confirm: "Confirmer",
        save: "Enregistrer",
        viewAll: "Voir tout",
        false: "faux",
        error: "Erreur",
        edit: "Modifier",
        mainAddress: "Adresse principale",
        recoverPassword: "Mot de passe oublié",
        resetPassword: "Réinitialiser le mot de passe",
        welcome: "Bienvenue",
        register: "Créer un compte",
        connect: "Connexion",
        newInvoice: "Nouvelle facture",
        didNotFindHelpContent: "Aucun contenu d'aide trouvé.",
        true: "vrai",
        yes: "oui",
        no: "non",
        Yes: "Oui",
        No: "Non",
        andmore: "de plus",
        noUser: "Aucun utilisateur",
        agents: "Agents",
        theFollowingMandatoryFieldsHaveNotBeenMapped:
            "Les champs obligatoires suivants n'ont pas été mappés :",
        anUnexpectedErrorHappenedPleaseContactUsForSupport:
            "Une erreur inconnue est survenue, veuillez nous contacter",
        dateRangeFromTo: "du {start} au {end}",
        dateRange: {
            label: "Période",
            placeholder: "Sélectionnez une période",
            apply: "Appliquer",
            cancel: "Annuler",
            modeLabel: "Données affichées",
            groupByLabel: "Grouper par",
        },
        navigation: {
            home: "Accueil",
            invitations: "Invitations",
            providers: "Fournisseurs",
            sell: "Vendre",
            sales: "Ventes",
            salesInsights: "Statistiques",
            search: "Recherche",
            commissions: "Commissions",
            customers: "Clients",
            communications: "Campagnes",
            customersInvoices: "Factures clients",
            invoices: "Factures",
            products: "Produits",
            catalogs: "Catalogues",
            allocations: "Allocations",
            logistics: "Logistique",
            stock: "Stock",
            shipments: "Expéditions",
            receipts: "Réceptions",
            movements: "Mouvements",
            logisticsProviders: "Logisticiens",
            inventory: "Inventaire",
            buy: "Acheter",
            purchaseOrders: "Achats",
            purchaseOrdersToApprove: "À approuver",
            providersInvoices: "Factures fournisseurs",
            comparator: "Comparateur",
            replenish: "Réapprovisionnement",
            toOrder: "À commander",
            technicalSheets: "Fiches techniques",
            production: "Production",
            radar: "Radar",
            agents: "Agents",
            establishments: "Établissements",
            caisses: "Caisses",
            billing: "Facturation",
            configuration: "Configuration",
            deliverySites: "Mes adresses",
            warehouses: "Entrepôts",
            productTypes: "Types de produits",
            feedback: "Feedback",
        },
        status_raw: "Statut",
        status: {
            canceled: "Annulé",
            closed: "Fermée",
            complete: "Complet",
            completed: "Finalisée",
            delivered: "Livrée",
            exhausted: "Épuisé",
            handling: "Traitement en cours",
            missing: "Manquant",
            new: "Nouveau",
            opened: "Ouverte",
            partial: "Partiel",
            pending: "En attente",
            pickedUp: "Enlevé",
            prepared: "Préparée",
            preparing: "En préparation",
            processed: "Traitée",
            processing: "En cours",
            shipping: "Livraison en cours",
            waiting: "En attente",
        },
        // Countries - French translations
        country: {
            ad: "Andorre",
            ae: "Émirats arabes unis",
            af: "Afghanistan",
            ag: "Antigua-et-Barbuda",
            ai: "Anguilla",
            al: "Albanie",
            am: "Arménie",
            ao: "Angola",
            aq: "Antarctique",
            ar: "Argentine",
            as: "Samoa américaines",
            at: "Autriche",
            au: "Australie",
            aw: "Aruba",
            ax: "Îles Åland",
            az: "Azerbaïdjan",
            ba: "Bosnie-Herzégovine",
            bb: "Barbade",
            bd: "Bangladesh",
            be: "Belgique",
            bf: "Burkina Faso",
            bg: "Bulgarie",
            bh: "Bahreïn",
            bi: "Burundi",
            bj: "Bénin",
            bl: "Saint-Barthélemy",
            bm: "Bermudes",
            bn: "Brunei",
            bo: "Bolivie",
            bq: "Pays-Bas caribéens",
            br: "Brésil",
            bs: "Bahamas",
            bt: "Bhoutan",
            bv: "Île Bouvet",
            bw: "Botswana",
            by: "Biélorussie",
            bz: "Belize",
            ca: "Canada",
            cc: "Îles Cocos",
            cd: "République démocratique du Congo",
            cf: "République centrafricaine",
            cg: "République du Congo",
            ch: "Suisse",
            ci: "Côte d'Ivoire",
            ck: "Îles Cook",
            cl: "Chili",
            cm: "Cameroun",
            cn: "Chine",
            co: "Colombie",
            cr: "Costa Rica",
            cu: "Cuba",
            cv: "Cap-Vert",
            cw: "Curaçao",
            cx: "Île Christmas",
            cy: "Chypre",
            cz: "République tchèque",
            de: "Allemagne",
            dj: "Djibouti",
            dk: "Danemark",
            dm: "Dominique",
            do: "République dominicaine",
            dz: "Algérie",
            ec: "Équateur",
            ee: "Estonie",
            eg: "Égypte",
            eh: "Sahara occidental",
            er: "Érythrée",
            es: "Espagne",
            et: "Éthiopie",
            fi: "Finlande",
            fj: "Fidji",
            fk: "Îles Malouines",
            fm: "Micronésie",
            fo: "Îles Féroé",
            fr: "France",
            ga: "Gabon",
            gb: "Royaume-Uni",
            gd: "Grenade",
            ge: "Géorgie",
            gf: "Guyane française",
            gg: "Guernesey",
            gh: "Ghana",
            gi: "Gibraltar",
            gl: "Groenland",
            gm: "Gambie",
            gn: "Guinée",
            gp: "Guadeloupe",
            gq: "Guinée équatoriale",
            gr: "Grèce",
            gs: "Géorgie du Sud et les îles Sandwich du Sud",
            gt: "Guatemala",
            gu: "Guam",
            gw: "Guinée-Bissau",
            gy: "Guyana",
            hk: "Hong Kong",
            hm: "Île Heard et îles McDonald",
            hn: "Honduras",
            hr: "Croatie",
            ht: "Haïti",
            hu: "Hongrie",
            id: "Indonésie",
            ie: "Irlande",
            il: "Israël",
            im: "Île de Man",
            in: "Inde",
            io: "Territoire britannique de l'océan Indien",
            iq: "Irak",
            ir: "Iran",
            is: "Islande",
            it: "Italie",
            je: "Jersey",
            jm: "Jamaïque",
            jo: "Jordanie",
            jp: "Japon",
            ke: "Kenya",
            kg: "Kirghizistan",
            kh: "Cambodge",
            ki: "Kiribati",
            km: "Comores",
            kn: "Saint-Kitts-et-Nevis",
            kp: "Corée du Nord",
            kr: "Corée du Sud",
            kw: "Koweït",
            ky: "Îles Caïmans",
            kz: "Kazakhstan",
            la: "Laos",
            lb: "Liban",
            lc: "Sainte-Lucie",
            li: "Liechtenstein",
            lk: "Sri Lanka",
            lr: "Libéria",
            ls: "Lesotho",
            lt: "Lituanie",
            lu: "Luxembourg",
            lv: "Lettonie",
            ly: "Libye",
            ma: "Maroc",
            mc: "Monaco",
            md: "Moldavie",
            me: "Monténégro",
            mf: "Saint-Martin",
            mg: "Madagascar",
            mh: "Îles Marshall",
            mk: "Macédoine du Nord",
            ml: "Mali",
            mm: "Myanmar",
            mn: "Mongolie",
            mo: "Macao",
            mp: "Îles Mariannes du Nord",
            mq: "Martinique",
            mr: "Mauritanie",
            ms: "Montserrat",
            mt: "Malte",
            mu: "Maurice",
            mv: "Maldives",
            mw: "Malawi",
            mx: "Mexique",
            my: "Malaisie",
            mz: "Mozambique",
            na: "Namibie",
            nc: "Nouvelle-Calédonie",
            ne: "Niger",
            nf: "Île Norfolk",
            ng: "Nigéria",
            ni: "Nicaragua",
            nl: "Pays-Bas",
            no: "Norvège",
            np: "Népal",
            nr: "Nauru",
            nu: "Niue",
            nz: "Nouvelle-Zélande",
            om: "Oman",
            pa: "Panama",
            pe: "Pérou",
            pf: "Polynésie française",
            pg: "Papouasie-Nouvelle-Guinée",
            ph: "Philippines",
            pk: "Pakistan",
            pl: "Pologne",
            pm: "Saint-Pierre-et-Miquelon",
            pn: "Îles Pitcairn",
            pr: "Porto Rico",
            ps: "Palestine",
            pt: "Portugal",
            pw: "Palaos",
            py: "Paraguay",
            qa: "Qatar",
            re: "La Réunion",
            ro: "Roumanie",
            rs: "Serbie",
            ru: "Russie",
            rw: "Rwanda",
            sa: "Arabie saoudite",
            sb: "Îles Salomon",
            sc: "Seychelles",
            sd: "Soudan",
            se: "Suède",
            sg: "Singapour",
            sh: "Sainte-Hélène",
            si: "Slovénie",
            sj: "Svalbard et Jan Mayen",
            sk: "Slovaquie",
            sl: "Sierra Leone",
            sm: "Saint-Marin",
            sn: "Sénégal",
            so: "Somalie",
            sr: "Suriname",
            ss: "Soudan du Sud",
            st: "São Tomé-et-Príncipe",
            sv: "Salvador",
            sx: "Sint Maarten",
            sy: "Syrie",
            sz: "Eswatini",
            tc: "Îles Turques-et-Caïques",
            td: "Tchad",
            tf: "Terres australes françaises",
            tg: "Togo",
            th: "Thaïlande",
            tj: "Tadjikistan",
            tk: "Tokelau",
            tl: "Timor oriental",
            tm: "Turkménistan",
            tn: "Tunisie",
            to: "Tonga",
            tr: "Turquie",
            tt: "Trinité-et-Tobago",
            tv: "Tuvalu",
            tw: "Taïwan",
            tz: "Tanzanie",
            ua: "Ukraine",
            ug: "Ouganda",
            um: "Îles mineures éloignées des États-Unis",
            us: "États-Unis",
            uy: "Uruguay",
            uz: "Ouzbékistan",
            va: "Vatican",
            vc: "Saint-Vincent-et-les-Grenadines",
            ve: "Venezuela",
            vg: "Îles Vierges britanniques",
            vi: "Îles Vierges des États-Unis",
            vn: "Vietnam",
            vu: "Vanuatu",
            wf: "Wallis-et-Futuna",
            ws: "Samoa",
            ye: "Yémen",
            yt: "Mayotte",
            za: "Afrique du Sud",
            zm: "Zambie",
            zw: "Zimbabwe",
        },
        variables: {
            amounts: "Montants",
            billed: "Facturé",
            billedName: "Nom facturé",
            billingAddress: "Adresse de facturation",
            buyer: "Acheteur",
            buyerName: "Nom de l'acheteur",
            contactEmail: "E-mail de contact",
            contactPhoneNumbers: "Téléphone(s) de contact",
            currency: "Devise",
            currencySymbol: "Symbole monétaire",
            customer: "Client",
            daysOverdue: "Jours de retard",
            dueDate: "Date d'échéance",
            dueDateLong: "Date d'échéance (long format)",
            insertVariables: "Insert variables",
            invoiceDate: "Date de la facture",
            invoiceDateLong: "Date de la facture (long format)",
            invoiceId: "Numéro de facture",
            invoiceInformation: "Informations de facture",
            issuer: "Vendeur",
            issuerAddress: "Adresse de l'émetteur",
            issuerContactEmail: "E-mail de contact de l'émetteur",
            issuerContactPhoneNumbers: "Téléphone de contact de l'émetteur",
            issuerName: "Nom de l'émetteur",
            items: "Articles",
            itemsCount: "Nombre d'articles",
            itemsSummary: "Résumé des articles",
            order: "Commande",
            orderDate: "Date de la commande",
            orderId: "Numéro de commande",
            parties: "Parties",
            seller: "Vendeur",
            sellerAddress: "Adresse du vendeur",
            sellerContactEmail: "Email(s) du vendeur",
            sellerContactPhoneNumbers: "Téléphone(s) du vendeur",
            sellerName: "Nom du vendeur",
            totalExclVat: "Total HT",
            totalInclVat: "Total TTC",
            totalVatAmount: "Montant total TVA",
            validatedDate: "Date de la commande",
            validatedDateLong: "Date de la commande (long format)",
        },
        filenames: {
            customerOrders: "commandes_clients.csv",
            customerOrderItems: "lignes_commandes_clients.csv",
            customerInvoices: "factures_client.csv",
            customerInvoiceItems: "lignes_factures_client.csv",
            providerInvoices: "factures_fournisseurs.csv",
            providerInvoiceItems: "facture_{invoice_number}_details.csv",
            providerOrders: "commandes_fournisseurs.csv",
            providerOrderItems: "lignes_commandes_fournisseurs.csv",
            shipments: "expeditions.csv",
            shipmentItems: "expedition_{shipment_id}_lignes.csv",
            receipts: "receptions.csv",
            receiptItems: "reception_{receipt_id}_lignes.csv",
            products: "produits.csv",
            catalogs: "catalogues.csv",
            catalogEntries: "catalogue_{catalog_name}_entrees.csv",
            productCatalogEntries: "catalogue_{catalog_name}_produits.csv",
            catalogsStockExport: "export_stocks_catalogues.csv",
            providerCatalogEntries: "produits_fournisseurs.csv",
            customers: "clients.csv",
            providers: "fournisseurs.csv",
            allocations: "allocations.csv",
            permissions: "permissions.csv",
            groups: "groupes.csv",
            movements: "mouvements.csv",
            movementsInventory: "mouvements_inventaire.csv",
            inventory: "inventaire_{date}.csv",
            stockProducts: "produits_stock.csv",
            commissions: "commissions.csv",
            commissionItems: "lignes_commissions.csv",
            labels: "etiquettes.pdf",
            invoicePdf: "facture_{invoice_number}.pdf",
            creditNotePdf: "avoir_{invoice_number}.pdf",
            productionPickList: "bon_prelevement_{establishment}_{date}.pdf",
            productionProductionSheet: "fiche_production_{establishment}_{date}.pdf",
            stock: "stock.csv",
        },
        inventoryPlaceholderDate: "Veuillez sélectionner une date ci-dessus pour afficher le tableau d'inventaire.",
        inventoryPlaceholderDateAndCustomer: "Veuillez sélectionner une date et un client ci-dessus pour afficher le tableau d'inventaire.",
        technicalSheet: "Fiche technique",
        product: "Produit",
        quantity: "Quantité",
        loss: "Perte",
        cost: "Coût",
        components: "Composants",
        totalCost: "Coût total",
        margin: "Marge",
        marginPercentage: "Marge %",
        description: "Description",
        noDescription: "Aucune description",
        sellingPrice: "Prix de vente",
        sellingPriceInclVat: "Prix de vente (TTC)",
        creationDate: "Date de création",
        modificationDate: "Date de modification",
        bundleInformation: "Informations de la fiche technique",
        search: "Recherche",
        units: {
            gram: "Gramme (g)",
            kilogram: "Kilogramme (kg)",
            liter: "Litre (L)",
            milliliter: "Millilitre (ml)",
            centiliter: "Centilitre (cl)",
            piece: "Pièce (pc)",
            grams: "Grammes (g)",
            kilograms: "Kilogrammes (kg)",
            liters: "Litres (L)",
            milliliters: "Millilitres (ml)",
            centiliters: "Centilitres (cl)",
            pieces: "Pièces (pc)",
        },
        unitSymbols: {
            g: "g",
            kg: "kg",
            l: "L",
            L: "L",
            ml: "ml",
            cl: "cl",
            pc: "",
        },
        unitTypes: {
            weight: "Poids",
            volume: "Volume",
            piece: "Pièce",
        },
        purchaseApproval: {
            title: "Approbation des achats",
            description: "Configurez le calcul des plafonds d'approbation des achats.",
            amountBasisLabel: "Montant utilisé pour les plafonds d'achat",
            amountBasisExclVat: "HT",
            amountBasisInclVat: "TTC",
            unlimited: "Illimité",
            limitGlobalLabel: "Plafond d'approbation des achats (global)",
            limitGlobalHint: "Vide = non défini (héritage groupe). 0 = toujours soumettre.",
            blockers: {
                amountOverLimit: "Le montant dépasse votre plafond d'approbation",
                approvalPending: "Une demande d'approbation est déjà en cours",
                approvalNotPending: "Aucune demande d'approbation en cours",
                approvalRequired: "Une approbation est requise avant validation",
                validatePermissionRequired:
                    "Vous n'avez pas la permission de valider les commandes fournisseur",
                changePermissionRequired:
                    "Vous n'avez pas la permission de modifier les commandes fournisseur",
                incompleteOrder: "Les prérequis de la commande ne sont pas remplis",
                missingDeliveryAddress: "L'adresse de livraison est incomplète",
                incompleteEntityInfo: "Les informations de l'entreprise sont incomplètes",
                orderSellerAddressMissing: "L'adresse email du fournisseur est manquante",
                orderAlreadyReady: "La commande a déjà été validée",
                approvalSuborderReadonly:
                    "L'approbation doit être gérée sur la commande parente",
                unknown: "La validation n'est pas possible pour une raison inconnue",
            },
        },
        customerTags: "Tags clients",
        assignedTo: "Attribué à",
        invoiceStatus: "Statut de facture",
        deliveryDateDesired: "Date de livraison souhaitée",
        lowstock: "Stock bas",
        orderType: {
            fieldName: "Type de commande",
            brokerageAndResale: "Agence et revente",
            brokerageOnly: "Agence seulement",
            resaleOnly: "Revente seulement",
        },
        stockRequired: "Veuillez sélectionner un stock",
        noValidItemsToDestock: "Aucun élément valide à déstocker",
        departureWarehouseUpdateFailed:
            "Échec de la mise à jour de l'entrepôt de départ",
        pickWarehouseTitle: "Sélectionnez un entrepôt",
        pickWarehouseHint:
            "Veuillez sélectionner un entrepôt de départ dans la liste ci-dessous.",
        "Fields errors, check form errors and try again":
            "Erreurs dans les champs, vérifiez le formulaire et réessayez",
        warning: "Attention",
        "Registering failed": "Échec de l'inscription",
        messages: {
            bulkActionPartiallyCompleted:
                "Action groupée terminée avec {errorcount} erreur(s)",
            bulkActionFailed: "Action groupée échouée pour {errorcount} élément(s)",
            missingPermission:
                "Vous n'avez pas la permission d'effectuer cette action.",
            cannotCompleteMasterOrderWithSuborders:
                "Cette commande possède des sous-commandes fournisseur. Finalisez chaque commande fournisseur individuellement plutôt que cette commande.",
            cannotCompleteSuborderAsAgent:
                "Cette sous-commande est gérée par un fournisseur connecté. Seul le fournisseur peut la finaliser.",
        },
        deliverysite: {
            cannotArchiveTitle: "Archivage impossible",
            cannotArchiveLinkedToWarehouse:
                "Ce site de livraison est lié à un entrepôt et ne peut pas être archivé. Archivez ou supprimez d'abord l'entrepôt associé (Paramètres → Entrepôts).",
        },
        ...posSyncMessagesFr,
        ...campaignsMessagesFr,
        ...customerFiltersMessagesFr,
    },
};
